import importsExportsImg from "../assets/imports-exports.png";

const ImportsExports = () => {
  return (
    <div
      style={{
        width: "100%",
        margin: 0,
        padding: 0,
      }}
    >
      <img
        src={importsExportsImg}
        alt="Imports and Exports"
        style={{
          width: "100%",
          height: "auto",
          display: "block",
        }}
      />
    </div>
  );
};

export default ImportsExports;